import React from 'react';
import PropTypes from "prop-types";
import { createMap, addMapListener } from "../../google";
import { asphaltMapsTheme } from "./asphaltMapsTheme";

import './style.css';
import { sendBaseMapLoadedFailureEvent, sendBaseMapLoadedSuccessEvent } from '../../googleAnalytics';
import { ClickstreamContext } from '../../providers/Clickstream.provider';

export default class GoogleMap extends React.Component {
  constructor(props) {
    super(props);
    this.mapLoaded = false;
  }
  static propTypes = {
    children: PropTypes.node,
  };
  startTime = null;
  mapName = "google";

  static contextType = ClickstreamContext;

  componentDidMount() {
    this.startTime = performance.now();
    const clickstream = this.context;
    try {
      this.mapInstance = createMap(this.mapDiv, {
        disableDefaultUI: true,
        clickableIcons: false,
        zoomControl: true,
        maxZoom: 17,
        styles: asphaltMapsTheme,
        gestureHandling: this.props.isGoSendPartnerOrder ? "greedy": "auto",
      });
      this.mapInstance.addListener('tilesloaded', () => {
        if (!this.mapLoaded) {
          this.mapLoaded = true;
          const timeTaken = performance.now() - this.startTime;
          this.trackMapLoadSuccess(clickstream, timeTaken);
        }
      });
      addMapListener(this.mapInstance, 'bounds_changed', this.props.onBoundsChange);
      this.forceUpdate();
    } catch(error) {
      this.trackMapLoadFailure(clickstream, error);
    }
  };

  trackMapLoadSuccess(clickstream, timeTaken) {
    sendBaseMapLoadedSuccessEvent(this.props.token, this.mapName, timeTaken);
    if (clickstream) {
      clickstream.track({
        eventName: "Map Load",
        baseMapLoad: {
          status: "success",
          map: this.mapName,
          tripId: this.props.token,
          loadTime: `${Math.round(timeTaken)}`,
        }
      });
    }
  }

  trackMapLoadFailure(clickstream, error) {
    sendBaseMapLoadedFailureEvent(this.props.token, this.mapName, error);
    if (clickstream) {
      clickstream.track({
        eventName: "Map Load",
        baseMapLoad: {
          status: "failed",
          map: this.mapName,
          tripId: this.props.token,
          errorMessage: `${error}`,
        }
      });
    }
  }

  render() {
    return (<div ref={(e) => this.mapDiv = e} className="GoogleMap">
      { this.mapInstance ?
        <GoogleMapContext.Provider value={this.mapInstance}>
        {this.props.children}
        </GoogleMapContext.Provider>
        : null }
      </div>);
  }
}

export const GoogleMapContext = React.createContext();
